// Small first-party catalog for local delivery fixtures; no purchase entitlement data.
export const optionalArtPacks = [
  { id: 'forest', label: 'pack.forest', manifest: '/packs/forest-art.json', cacheKey: '/packs/forest-art.svg', paths: ['/packs/forest-art.svg', '/packs/forest-art.webp', '/packs/forest-art.pack'], bytes: 983976 },
  { id: 'ocean', label: 'pack.ocean', manifest: '/packs/ocean-art.json', cacheKey: '/packs/ocean-art.webp', paths: ['/packs/ocean-art.webp', '/packs/ocean-art.pack'], bytes: 1006766 },
] as const;

export function optionalArtPack(id: string) {
  const pack = optionalArtPacks.find(pack => pack.id === id);
  if (!pack) throw new Error('Unknown artwork pack');
  return pack;
}
